export const eventTransitionEndByHeight = (event) => {
  if (event.propertyName !== 'height') return
  event.currentTarget.style.height = ''
  event.currentTarget.removeEventListener('transitionend', eventTransitionEndByHeight)
}